/** * NewsItem2 * @author wwl * @created 2023/5/31 * @modified 2023/5/31 */
<template>
  <div class="news-left">
    <div class="news-cover">
      <nuxt-link
        :to="handleNewsUrl(news.viewUrl, news.newsId)"
        :title="news.newsName"
        target="_blank">
        <!-- <img
          v-webp
          :src="news.logo"
          :alt="news.newsName"
          loading="lazy"
          rel="nofollow,noindex" /> -->
        <img
          :src="news.logo ? news.logo + getXOssWebpSize({ w: 400, h: 200 }) : ''"
          :alt="news.newsName"
          loading="lazy"
          rel="nofollow,noindex" />
      </nuxt-link>
    </div>
    <div class="news-info">
      <p class="name">
        <i
          style="width: 24px"
          class="el-icon-toutiao"></i>
        <span>
          <nuxt-link
            :to="handleNewsUrlMethod(news.viewUrl, news.newsId)"
            :title="news.newsName"
            target="_blank">
            {{ news.newsName }}
          </nuxt-link>
        </span>
      </p>
      <p class="time">
        <span style="margin-right: 15px">
          {{ news.publishTime }}
        </span>
        <i
          style="width: 12px; margin-right: 4px"
          class="el-icon-look"></i>
        <span>{{ news.views || 0 }}</span>
      </p>
      <div class="content">
        {{ news.description }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { defineProps } from 'vue'
  import { handleNewsUrl } from '~/utils/common'

  // 定义组件的 props
  defineProps({
    news: {
      type: Object,
      default: () => ({})
    }
  })

  // 处理新闻 URL 的方法
  const handleNewsUrlMethod = handleNewsUrl
</script>

<style lang="less" scoped>
  .news-left {
    width: 590px;
    padding: 0 16px;
    margin: 0 10px 10px 0;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 6px;

    &:nth-child(2n) {
      margin-right: 0;
    }

    .news-cover {
      width: 200px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      border: 1px solid #ddd;
      margin-right: 10px;
      border-radius: 4px;
      flex-shrink: 0;

      img {
        width: 200px;
        height: 100px;
        object-fit: cover;
      }
    }

    .news-info {
      width: calc(100% - 210px);
      height: 100%;
      padding: 4px 0;

      .name {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        //width: 420px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .time {
        display: flex;
        font-size: 14px;
        color: #999;
        margin-top: 10px;
      }

      .content {
        margin-top: 18px;
        line-height: 24px;
        font-size: 14px;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 3; //显示的行
      }
    }
  }
</style>
